<template>
    <v-container fluid>
        <v-layout column wrap>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>
<script>
    export default {}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/config/index.vue